
import { defineComponent, onMounted, ref } from "vue";
import MiddleHeader from "@/components/MiddleHeader.vue";
import HorizontalListSelectSample from "@/components/HorizontalListSelectSample.vue";
import TemplateThumbnailSelectSample from "@/components/TemplateThumbnailSelectSample.vue";
import store from "@/stores";
import { microWait } from "@/lib/shared";
import { ITemplateSet, ISampleSet, IAttribute } from "@/services/Models";

export default defineComponent({
  name: "SelectSampleData",
  components: {
    MiddleHeader,
    HorizontalListSelectSample,
    TemplateThumbnailSelectSample,
  },
  setup() {
    const resource = store.useResource();
    const currentAttribute = ref(0);
    const sampleDatas = ref<ISampleSet[]>([]);
    const sampleAttribute = ref<IAttribute[]>([]);
    const horizontalList = ref();

    onMounted(() => {
      sampleAttribute.value = resource.data.sampleAttributes.sort(
        (a, b) => a.id - b.id
      );
      currentAttribute.value = sampleAttribute.value[0].id;
      selectAttribute(currentAttribute.value);
    });

    // 属性選択時処理
    const selectAttribute = (attribute: number) => {
      updateAttributeButton(attribute);

      // 選択されたカテゴリでサンプル再検索
      horizontalList.value.pageIndex = 0;
      sampleDatas.value = resource.data.sampleSets.filter((x) =>
        x.tags.some((tag) => tag.id == attribute)
      );
    };

    // 属性ボタン表記の更新
    const updateAttributeButton = async (category: number) => {
      await microWait();
      sampleAttribute.value.forEach((x) => {
        var id = x.id.toString();
        var btnElem = document.getElementById(id) as HTMLElement;
        if (category == x.id) {
          if (btnElem.classList.contains("selected-button")) return;
          btnElem.classList.replace("unselected-button", "selected-button");
        } else {
          if (btnElem.classList.contains("unselected-button")) return;
          btnElem.classList.replace("selected-button", "unselected-button");
        }
      });
    };

    const emptyTemplate: ITemplateSet = {
      id: -1,
      describe: "",
      frames: [],
      thumbnail: "",
      tags: [],
      deleteFlg: false,
    };

    return {
      sampleDatas,
      sampleAttribute,
      emptyTemplate,
      horizontalList,
      selectAttribute,
    };
  },
});
